import Modal from "~/components/Modal";
import type { IShoppingListItem } from "~/providers/interfaces";
import { getAmount, trans } from "~/utils/trans";

import "./style.less";

interface IShoppingListModal {
	items: Array<IShoppingListItem>;
	onClose?: () => void;
}

export default function ShoppingListModal({
	items = [],
	onClose = () => {},
}: IShoppingListModal) {
	return <Modal onClose={onClose} className="shoppingListModal">
		<div className="inner-cont">
			<div className="recipe-area">
				<h2>
					{trans("shopping.title")}
				</h2>
				<table className="ingredientsTable">
					<thead>
						<tr>
							<th colSpan={2}>{trans("shopping.ingredient")}</th>
							<th className="right">{trans("common.quantity")}</th>
						</tr>
					</thead>
					<tbody>
						{items.map(ingredient => <tr key={ingredient.name}>
							<td colSpan={2}>
								{ingredient.name}
							</td>
							<td className="right">
								{ getAmount({
									id: 0,
									multiple: ingredient.count,
									name: ingredient.name,
									unit: ingredient.unit_name,
								}) }
							</td>
						</tr>) }
					</tbody>
				</table>
			</div>
		</div>
	</Modal>;
}
